import { setExperimentationUser } from '#src/lib/experimentation';

import { getUserStatusInfo } from './get-user-status-info';
import { updateFacebookPixelUserData } from './update-facebook-pixel-user-data';

export async function identify(user) {
  try {
    const userStatusInfo = await getUserStatusInfo(user);
    analytics.identify(user.id, userStatusInfo);
    setExperimentationUser({ ...userStatusInfo, ...user });
    updateFacebookPixelUserData(userStatusInfo); // ensures that subsequent facebook track events include user info for better matching
  } catch (e) {
    console.error(e);
  }
}
